<style>
    .signup-page .ivu-form .ivu-form-item{
        margin-bottom: 10px;
    }

    .confirm-row .left{
        text-align: right;
        padding-right: 10px;
    }

    .confirm-row .right{
        text-align: left;
        padding-left:10px;
    }

    .hide{
        display: none;
    }
</style>

<template>
    <div class="signup-page">
        <card >
            <Alert show-icon>
                1、一对一课程报名：选择学员、课程、教师，增加上课时间，录入缴费和课时信息，点击保存。
                <br>
                2、班课报名：选择学员、课程、教师，选择班级，录入开始上课时间，录入缴费和课时信息，点击保存。
                <br>
                3、如果是老学员，点击“选择已有学员”，选择相应学员。如果是新学员，直接录入学员信息即可
                <br>
                4、如果是预约的，勾选“是否预约”即可，报名预约试听的话就不用输入费用和课时了。
                <br>
            </Alert>
            <card style="margin-bottom: 10px;">
                <p slot="title">基本信息</p>
                <Row type="flex" justify="center" v-if="chooseStudentType">
                    <Col span="24" style="text-align: center">
                        <Button type="primary" size="large" style="margin-right: 50px;" @click="newStudent">新学员报名</Button>
                        <Button type="primary" size="large" @click="chooseStudent">选择已有学员</Button>
                    </Col>
                </Row>
                <Button slot="extra" type="primary" @click="chooseStudent" :class="{hide:chooseStudentType || baseForm.id || baseForm.isNewStudent}" >选择已有学员</Button>
                <Button slot="extra" type="warning" @click="clearChoosedStudent" :class="{hide:chooseStudentType || !baseForm.id}" >清除所选</Button>
                <div v-if="!chooseStudentType">
                    <Form :model="baseForm" ref="baseForm" :label-width="80">
                        <Row :gutter="16">
                            <Col span="12">
                                <FormItem label="学员姓名" class="ivu-form-item-required">
                                    <Input v-model="baseForm.name" placeholder="新生报到直接填写姓名，如要选择已有学员请点击右侧按钮" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="所在校区" class="ivu-form-item-required">
                                    <Select v-model="baseForm.zoneId" :disabled="!baseForm.isNewStudent" @on-change="changeZone" :label-in-value="true">
                                        <Option v-for="zone in zoneList" :value="zone.id" :key="zone.id">{{ zone.name }}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="12">
                                <FormItem label="性别" >
                                    <RadioGroup v-model="baseForm.sex" >
                                        <Radio :label="1" :disabled="!baseForm.isNewStudent">男</Radio>
                                        <Radio :label="2" :disabled="!baseForm.isNewStudent">女</Radio>
                                    </RadioGroup>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="生日" >
                                    <DatePicker type="date" placeholder="选择日期"
                                                format="yyyy-MM-dd" @on-change="baseForm.birth=$event"
                                                :value="baseForm.birth" :readonly="!baseForm.isNewStudent"></DatePicker>
                                </FormItem>
                            </Col>
                        </Row>
                        <Alert>联系人手机号用于绑定家长手机端查课系统</Alert>
                        <Row :gutter="16">
                            <Col span="12">
                                <FormItem label="联系人1姓名" >
                                    <Input v-model="baseForm.linkman1" placeholder="联系人1姓名" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="联系人1电话" >
                                    <Input v-model="baseForm.linkman1mobile" placeholder="联系人1电话" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="12">
                                <FormItem label="联系人2姓名" >
                                    <Input v-model="baseForm.linkman2" placeholder="联系人2姓名" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="联系人2电话" >
                                    <Input v-model="baseForm.linkman2mobile" placeholder="联系人2电话" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="24">
                                <FormItem label="备注">
                                    <Input v-model="baseForm.remark" placeholder="备注" :readonly="!baseForm.isNewStudent"/>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </card>
            <card style="margin-bottom: 10px;">
                <p slot="title">报名信息</p>
                <Row type="flex" justify="center" v-if="chooseSignType">
                    <Col span="24" style="text-align: center">
                        <Button type="primary" size="large" style="margin-right: 50px;" @click="signupOne">一对一课程报名</Button>
                        <Button type="primary" size="large" @click="signupClazz">班课报名</Button>
                    </Col>
                </Row>
                <div v-if="signupTypeOne">
                    <Row style="margin-bottom: 20px;">
                        <Col span="24">
                            <span style="margin-right: 10px;">{{clazzForm.courseName}}</span>
                            <Tag color="primary" style="margin-right: 10px;">一对一</Tag>
                            <Tag color="primary" style="margin-right: 10px;">{{baseForm.zoneName}}</Tag>
                            <Select v-model="clazzForm.teacherId" style="width:200px;" placeholder="选择教师" filterable @on-change="changeTeacher" :label-in-value="true">
                                <Option v-for="(item,index) in teacherList" :key="index" :value="item.id">{{item.name}}
                                </Option>
                            </Select>
                            <!--<Button type="text" size="small">查看老师已排课程</Button>-->
                            <Checkbox v-model="clazzForm.isAppointment" style="margin-left: 10px;">是否预约试听</Checkbox>
                            &nbsp;
                            每次上课扣除学员课时数：
                            <Input v-model="clazzForm.hour_num" placeholder="" style="width:60px;" />
                            <!--<Button type="primary" style="margin-left: 100px" size="small" @click="addClassTime">新增上课时间</Button>-->
                        </Col>
                    </Row>
                    <Form :label-width="100" ref="clazzTimeForm" v-if="!clazzForm.isAppointment">
                        <Row>
                            <Col span="24">
                                <FormItem label="课程起止时间" class="ivu-form-item-required">
                                    <DatePicker :value="clazzForm.daterange" type="daterange" split-panels placeholder="选择时间范围" style="width: 300px"
                                                format="yyyy-MM-dd" @on-change="clazzForm.daterange=$event"></DatePicker>
                                </FormItem>
                            </Col>
                            <!--<Col span="24">-->
                                <!--<FormItem label="课时数" >-->
                                    <!--<Input v-model="clazzForm.hours" placeholder="不填则排满，填的话则最多排到对应课时的课"/>-->
                                <!--</FormItem>-->
                            <!--</Col>-->
                        </Row>
                        <TimeList :timeList="clazzForm.timeList"></TimeList>
                    </Form>
                    <Form :label-width="100" ref="clazzTimeForm" v-if="clazzForm.isAppointment">
                        <Row>
                            <Col span="24">
                                <FormItem label="上课时间" class="ivu-form-item-required">
                                    <DatePicker :value="clazzForm.appointmentDate" type="date" placeholder="选择上课时间" style="width: 300px"
                                                format="yyyy-MM-dd" @on-change="clazzForm.appointmentDate=$event"></DatePicker>
                                </FormItem>
                            </Col>
                            <Col span="24">
                                <FormItem label="时间段" class="ivu-form-item-required">
                                    <Select :value="clazzForm.appointmentStart + ' - ' + clazzForm.appointmentEnd" style="width: 200px;" @on-change="appointmentTimeChange($event)">
                                        <Option v-for="(timeRange,index) in timeRangeList" :key="index" :value="timeRange.start + ' - ' + timeRange.end">{{(timeRange.start + ' - ' + timeRange.end)}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <Row v-if="signupTypeClass">
                    <Row style="margin-bottom: 20px;">
                        <Col span="24">
                            <span style="margin-right: 10px;">{{clazzForm.clazzName}}</span>
                            <Tag color="primary" style="margin-right: 10px;">班课</Tag>
                            <Tag color="primary" style="margin-right: 10px;">{{baseForm.zoneName}}</Tag>
                            <!--<Select v-model="clazzForm.teacherId" style="width:200px;" disabled>-->
                                <!--<Option v-for="(item,index) in teacherList" :key="index" :value="item.id">{{item.name}}-->
                                <!--</Option>-->
                            <!--</Select>-->
                            <Checkbox v-model="clazzForm.isAppointment" style="margin-left:10px;">是否预约试听</Checkbox>
                        </Col>
                    </Row>
                    <div>
                        <Alert v-html="clazzForm.clazzInfo"></Alert>
                    </div>
                    <Form :label-width="100" ref="clazzTimeForm" v-if="!clazzForm.isAppointment">
                        <Row>
                            <Col span="24">
                                <FormItem label="开始上课时间">
                                    <DatePicker :value="clazzForm.startDate" type="date" placeholder="" style="width: 400px"
                                                format="yyyy-MM-dd" @on-change="clazzForm.startDate=$event"></DatePicker>

                                    <span style="color:#3765ff;margin-left:5px;">
                                        <Icon type="md-alert" size="18"/>如果班级未确定上课时间，可以不填等后面班级统一排课
                                    </span>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <Form :label-width="100" ref="clazzTimeForm" v-if="clazzForm.isAppointment">
                        <Row>
                            <Col span="24">
                                <FormItem label="上课时间" class="ivu-form-item-required">
                                    <DatePicker :value="clazzForm.appointmentDate" type="date" placeholder="选择上课时间" style="width: 300px"
                                                format="yyyy-MM-dd" @on-change="clazzForm.appointmentDate=$event"></DatePicker>
                                </FormItem>
                            </Col>
                            <Col span="24">
                                <FormItem label="时间段" class="ivu-form-item-required">
                                    <Select :value="clazzForm.appointmentStart + ' - ' + clazzForm.appointmentEnd" style="width: 200px;" @on-change="appointmentTimeChange($event)">
                                        <Option v-for="(timeRange,index) in timeRangeList" :key="index" :value="timeRange.start + ' - ' + timeRange.end">{{(timeRange.start + ' - ' + timeRange.end)}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </card>
            <card style="margin-bottom: 10px;" v-if="!clazzForm.isAppointment">
                <p slot="title">支付信息</p>
                <Form :model="payForm" ref="payForm" inline :label-width="100">
                    <FormItem label="支付金额" class="ivu-form-item-required">
                        <Input placeholder="支付金额" v-model="payForm.money" style="width: 200px;"/>
                    </FormItem>
                    <FormItem label="购买课时" class="ivu-form-item-required">
                        <Input placeholder="购买课时" v-model="payForm.hours" style="width: 200px;"/>
                    </FormItem>
                    <FormItem label="付款方式" class="ivu-form-item-required">
                        <Select v-model="payForm.paytype" style="width:120px;">
                            <Option label="微信" value="微信"></Option>
                            <Option label="支付宝" value="支付宝"></Option>
                            <Option label="现金" value="现金"></Option>
                            <Option label="银联" value="银联"></Option>
                            <Option label="其他" value="其他"></Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注 ">
                        <Input placeholder="备注" v-model="payForm.remark" style="width: 500px;"/>
                    </FormItem>
                </Form>
            </card>
            <Row type="flex" justify="center">
                <Col span="6">
                    <Button type="primary" size="large" long @click="submit">提交</Button>
                </Col>
            </Row>
        </card>
        <Modal v-model="showOneToOneCourseModal" title="一对一课程选择"  width="800">
            <Form inline>
                <FormItem><Input placeholder="搜索课程" v-model="courseKeyword"/></FormItem>
                <FormItem>
                    <Button type="primary" @click="searchCourse" size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="oneToOneCourseColumns" :data="oneToOneCourseData"></Table>
            <div slot="footer"></div>
        </Modal>
        <Modal v-model="showClassCourseModal" title="选择班级"  width="800">
            <Form inline>
                <FormItem><Input placeholder="搜索班级" v-model="classKeyword"/></FormItem>
                <FormItem>
                    <Button type="primary" @click="searchClass" size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="classCourseColumns" :data="classCourseData"></Table>
            <Page :total="classPageTotalNum" :current="classPageCurrent" v-if="classShowPager" show-elevator show-total
                  @on-change="classChangePage" :page-size="20" ></Page>
            <div slot="footer"></div>
        </Modal>
        <Modal v-model="studentModal" title="学员选择" width="800">
            <Form inline>
                <FormItem><Input placeholder="搜索学员" v-model="studentKeyword"/></FormItem>
                <FormItem>
                    <Button type="primary" @click="getStudentList" size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="studentColumns" :data="studentData" ></Table>
            <Page :total="studentPageTotalNum" :current="studentPageCurrent" v-if="studentShowPager" show-elevator show-total
                  @on-change="studentChangePage" :page-size="20" ></Page>
            <div slot="footer"></div>
        </Modal>
        <Modal v-model="confirmWin" width="660">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>核对报名数据（不可撤销）</span>
            </p>
            <div style="text-align:center;font-size:14px;font-weight: bold">
                <Row class="confirm-row">
                    <Col span="10" class="left">
                        姓名：
                    </Col>
                    <Col span="12" class="right">
                        {{baseForm.name}}（ {{baseForm.isNewStudent?'新学员':'老学员'}} ）
                    </Col>
                </Row>
                <Row class="confirm-row">
                    <Col span="10" class="left">
                        校区：
                    </Col>
                    <Col span="12" class="right">
                        {{baseForm.zoneName}}
                    </Col>
                </Row>
                <div v-if="clazzForm.courseType == 1">
                    <Row class="confirm-row">
                        <Col span="10" class="left">
                            课程：
                        </Col>
                        <Col span="12" class="right">
                            【一对一】{{clazzForm.courseName}}  {{clazzForm.isAppointment?'（预约）':''}}
                        </Col>
                    </Row>
                    <Row class="confirm-row">
                        <Col span="10" class="left">
                            教师：
                        </Col>
                        <Col span="12" class="right">
                            {{clazzForm.teacherName}}
                        </Col>
                    </Row>
                    <div v-if="clazzForm.isAppointment">
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课日期：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.appointmentDate}}
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课时间：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.appointmentStart}} - {{clazzForm.appointmentEnd}}
                            </Col>
                        </Row>
                    </div>
                    <div v-else>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课日期：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.daterange[0]}} 至 {{clazzForm.daterange[1]}}
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课时间：
                            </Col>
                            <Col span="12" class="right">
                                <div v-for="(time) in clazzForm.timeList">
                                    {{time.start}} - {{time.end}} (星期 {{time.weekday}} )
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <div v-if="!clazzForm.isAppointment">
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                每次扣除课时数：
                            </Col>
                            <Col span="12" class="right">
                                <span style="color:red">扣除{{clazzForm.hour_num}}课时/次课</span>
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                缴费金额：
                            </Col>
                            <Col span="12" class="right">
                                <span style="color:red">¥{{payForm.money}}</span>
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                购买课时：
                            </Col>
                            <Col span="12" class="right">
                                <span style="color:red">{{payForm.hours}}节课</span>
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                付款方式：
                            </Col>
                            <Col span="12" class="right">
                                {{payForm.paytype}}
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                备注：
                            </Col>
                            <Col span="12" class="right">
                                {{payForm.remark}}
                            </Col>
                        </Row>
                    </div>
                </div>
                <div v-else-if="clazzForm.courseType == 2">
                    <Row class="confirm-row">
                        <Col span="10" class="left">
                            课程：
                        </Col>
                        <Col span="12" class="right">
                            【班课】{{clazzForm.clazzName}} {{clazzForm.isAppointment?'（ 预约 ）':''}}
                        </Col>
                    </Row>
                    <div v-if="clazzForm.isAppointment">
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课日期：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.appointmentDate}}
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课时间：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.appointmentStart}} - {{clazzForm.appointmentEnd}}
                            </Col>
                        </Row>
                    </div>
                    <div v-else>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                预约上课日期：
                            </Col>
                            <Col span="12" class="right">
                                {{clazzForm.startDate}}
                            </Col>
                        </Row>
                    </div>
                    <div v-if="!clazzForm.isAppointment">
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                缴费金额：
                            </Col>
                            <Col span="12" class="right">
                                <span style="color:red">¥{{payForm.money}}</span>
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                购买课时：
                            </Col>
                            <Col span="12" class="right">
                                <span style="color:red">{{payForm.hours}}节课</span>
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                付款方式：
                            </Col>
                            <Col span="12" class="right">
                                {{payForm.paytype}}
                            </Col>
                        </Row>
                        <Row class="confirm-row">
                            <Col span="10" class="left">
                                备注：
                            </Col>
                            <Col span="12" class="right">
                                {{payForm.remark}}
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="saving" @click="doSignUp">确认无误，提交数据</Button>
            </div>
        </Modal>
        <Modal v-model="teacherModal" title="老师已排课程">
            <Table :columns="columns3" :data="data3"></Table>
        </Modal>

    </div>
</template>
<script>
  import TimeList from '../common/timelist.vue';

  export default {
    name: 'signup',
    data() {
      return {
        chooseStudentType:true,
        confirmWin:false,
        studentKeyword:null,
        studentTotalPage:0,
        studentPageTotalNum:0,
        studentPageCurrent:1,
        classTotalPage:0,
        classPageTotalNum:0,
        classPageCurrent:1,
        saving:false,
        showOneToOneCourseModal:false,
        showClassCourseModal:false,
        classTimeModal: false,
        teacherModal: false,
        studentModal: false,
        pretime: '9:00-10:00',
        clickType: '',
        showModal: false,
        pre: false,
        chooseSignType: true,
        signupTypeOne: false,
        signupTypeClass: false,
        baseForm: {
          isNewStudent:true,
          id:null,
          name: '',
          zoneId:null,
          zoneName:null,
          sex: 1,
          birth: '',
          remark: '',
          linkman1: '',
          linkman1mobile: '',
          linkman2: '',
          linkman2mobile: ''
        },
        clazzForm:{
          teacherId:null,
          teacherName:null,
          courseType:null,
          courseName:null,
          courseId:null,
          daterange: [],
          timeList:[],
          startDate:null,
          isAppointment:false,
          appointmentDate:null,
          appointmentStart:null,
          appointmentEnd:null,
          clazzId:null,
          clazzName:null,
          hours:null,
          clazzInfo:null,
          hour_num:1
        },
        payForm: {
          money: null,
          hours: null,
          remark:null,
          paytype:null
        },
        teacherList: this.$store.state.app.teacherList,
        oneToOneCourseColumns: [
          {
            title: '课程名称',
            key: 'name',
          },
          {
            title: '课程类别',
            key: 'cateName'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this;
              let opArray = [];
              opArray.push(h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.showOneToOneCourseModal = false;
                    self.chooseSignType = false;
                    self.signupTypeOne = true;
                    self.clazzForm.courseName = params.row.name;
                    self.clazzForm.courseType = 1;
                    self.clazzForm.courseId = params.row.id;
                  }
                }
              }, '选择'));
              return h('div', opArray);
            }
          }
        ],
        oneToOneCourseData: this.$store.state.app.oneToOneCourseList,
        classCourseColumns:[
          {
            title: '班级名称',
            key: 'name',
          },
          {
            title: '开班时间',
            render: (h, params) => {
              let self = this;
              let contentArray = [];
              if (params.row.dateList && params.row.dateList.length > 0){
                params.row.dateList.forEach(ele => {
                  contentArray.push(h('div', {}, "["+ele.teacherName + "] " + ele.begin_date + ' 到 ' + ele.end_date));
                  ele.timeList.forEach((item, idx) => {
                    contentArray.push(h('div', {}, self.$xmutils.parseWeekDay(item.weekday) + item.start + ' - ' + item.end));
                  });
                });
              }

              return h('div', contentArray);
            }
          },
          {
            title: '校区',
            key: 'zone_name',
            width:100
          },
          {
            title: '操作',
            align: 'center',
            width:100,
            render: (h, params) => {
              let self = this;
              let opArray = [];
              opArray.push(h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.showClassCourseModal = false;
                    self.chooseSignType = false;
                    self.signupTypeClass = true;
                    self.clazzForm.clazzName = params.row.name;
                    self.clazzForm.courseName = params.row.course_name;
                    self.clazzForm.courseType = 2;
                    self.clazzForm.courseId = params.row.course_id;
                    self.clazzForm.clazzId = params.row.id;
                    self.clazzForm.teacherId = params.row.teacher_id;

                    let classInfo = '课程：' + params.row.course_name + '<br>';
                    if (params.row.dateList && params.row.dateList.length > 0){
                      params.row.dateList.forEach(ele => {
                        let contentArray = [];
                        contentArray.push(ele.begin_date + ' 到 ' + ele.end_date);
                        ele.timeList.forEach((item,idx)=>{
                          contentArray.push(self.$xmutils.parseWeekDay(item.weekday) + ' (' + item.start + ' - ' + item.end + ')');
                        });
                        classInfo += contentArray.join(' | ')+'<br>';
                      });
                    }
                    self.clazzForm.clazzInfo = classInfo;
                  }
                }
              }, '选择'));
              return h('div', opArray);
            }
          }
        ],
        classCourseData:[],
        studentColumns: [
          {
            title:'校区',
            key:'zoneName',
            align:'center'
          },
          {
            title:'姓名',
            key:'name',
            align:'center'
          },
          {
            title:'性别',
            key:'sex',
            align:'center',
            render: (h, params) => {
              let self = this;
              let opArray = [];
              let sex = '';
              if (params.row.sex == 1){
                sex = '男'
              }else if (params.row.sex == 2){
                sex = '女';
              }
              opArray.push(h('span', {}, sex));
              return h('div', {}, opArray);
            }
          },
          {
            title:'家长',
            key:'parent',
            align:'center'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this;
              let opArray = [];
              opArray.push(h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$api.student.getParentsList({student_id:params.row.id}).then(res=>{
                      if(res.state == 'ok'){
                        let linkman1 = '',linkman1mobile = '',linkman2 = '',linkman2mobile='';
                        if (res.parentsList.length > 0){
                          linkman1 = res.parentsList[0].name;
                          linkman1mobile = res.parentsList[0].mobile;
                        }
                        if (res.parentsList.length > 1) {
                          linkman2 = res.parentsList[1].name;
                          linkman2mobile = res.parentsList[1].mobile;
                        }

                        this.chooseStudentType = false;
                        this.baseForm = {
                          isNewStudent:false,
                          zoneId:params.row.zone_id,
                          zoneName:params.row.zoneName,
                          id: params.row.id,
                          name: params.row.name,
                          sex: params.row.sex,
                          birth: params.row.birthday,
                          remark: params.row.remark,
                          linkman1: linkman1,
                          linkman1mobile: linkman1mobile,
                          linkman2: linkman2,
                          linkman2mobile: linkman2mobile,
                        }
                      }else{
                        this.$Message.error(res.msg)
                      }
                    });
                    this.studentModal = false

                  }
                }
              }, '选择'));
              return h('div', opArray);
            }
          }
        ],
        studentData: [],
        columns3: [
          {
            title: '姓名',
            key: 'name'
          },
          {
            title: '课程',
            key: 'course',
          },
          {
            title: '日期',
            key: 'classdate'
          },
          {
            title: '时间段',
            key: 'time'
          },
          {
            title: '休假 ',
            key: 'vacation'
          }
        ],
        data3: [],
        courseKeyword:null,
        classKeyword:null,

      }
    },
    methods: {
      newStudent(){
        this.chooseStudentType = false;
      },
      doSignUp(){
        let self = this;
        self.saving = true;
        self.$api.biz.signup(self.packagingFormData()).then(resp=>{
          self.saving = false;
          if (resp.state == 'ok') {
            self.$Message.info({
              content: '保存成功',
              onClose() {
                self.$store.commit('closeTag',{
                  name:'signup'
                });
                self.$router.push({
                  name: 'home'
                })
              }
            });
          } else {
            self.$Message.info({
              content: resp.msg,
              duration: 10,
              closable:true
            });
          }
        });
      },
      changeZone(val){
        this.baseForm.zoneName = val.label;
      },
      changeTeacher(val){
        this.clazzForm.teacherName = val.label;
      },
      clearChoosedStudent(){
        this.baseForm = {
          isNewStudent:true,
          zoneId:this.zoneList[0].id,
          zoneName:this.zoneList[0].name,
          id: null,
          name: null,
          sex: 1,
          birth: null,
          remark: null,
          linkman1: null,
          linkman1mobile: null,
          linkman2: null,
          linkman2mobile: null,
        }
        this.clazzForm={
          teacherId:null,
            courseType:null,
            courseName:null,
            courseId:null,
            daterange: [],
            timeList:[],
            isAppointment:false,
            appointmentDate:null,
            appointmentStart:null,
            appointmentEnd:null,
            clazzId:null,
            hours:null,
        },
        this.payForm= {
          money: null,
          hours: null,
          remark:null,
          paytype:null
        }
        this.chooseStudentType = true;
      },
      getStudentList() {
        this.studentPageTotalNum=0;
        this.studentData=[]
        let param ={
          page:this.studentPageCurrent,
          keyword:this.studentKeyword
        }
        this.$api.student.list(param).then(res=>{
          if(res.state=="ok"){
            this.studentPageTotalNum = res.data.totalRow;
            this.studentTotalPage = res.data.totalPage;
            this.studentPageCurrent = res.data.pageNumber;
            this.studentData=res.data.list;
          }else{
            this.$Message.error(res.msg)
          }
        })
      },
      getClassList(){
        let param = {
          pageNumber:this.classPageCurrent,
          pageSize:20,
          zone_id : this.baseForm.zoneId,
          state:1,
          keyword:this.classKeyword
        }
        this.$api.clazz.getList(param).then(resp => {
          this.classCourseData = resp.data.list;
          this.classPageTotalNum = resp.data.totalRow;
          this.classTotalPage = resp.data.totalPage;
          this.classPageCurrent = resp.data.pageNumber;
        });
      },
      studentChangePage (page) {
        this.studentPageCurrent = page;
        this.getStudentList();
      },
      classChangePage (page) {
        this.classPageCurrent = page;
        this.getClassList();
      },
      signupOne() {
        this.showOneToOneCourseModal = true;
        this.courseKeyword = null;
        this.oneToOneCourseData=this.$store.state.app.oneToOneCourseList;
      },
      signupClazz() {
        this.getClassList();
        this.showClassCourseModal = true;
      },
      chooseStudent() {
        this.getStudentList();
        this.studentModal = true;
      },
      checkData(){
        let self = this;
        if (self.baseForm.isNewStudent){
          if (!self.baseForm.name){
            self.$Message.error("请输入学员姓名");
            return false;
          }
        }
        if (!self.clazzForm.courseType){
          self.$Message.error("请选择课程或者班级");
          return false;
        }

        if (self.clazzForm.isAppointment){
            if (!self.clazzForm.appointmentDate){
            self.$Message.error("请选择预约试听日期");
            return false;
          }

          if (!self.clazzForm.appointmentStart || !self.clazzForm.appointmentEnd){
            self.$Message.error("请选择预约试听时间段");
            return false;
          }
        }else{
          if (self.clazzForm.courseType==1){
            if (!self.clazzForm.hour_num){
              self.$Message.error("请输入每次扣除课时数");
              return false;
            }
            if (!self.clazzForm.teacherId){
              self.$Message.error("请选择教师");
              return false;
            }
            if (!self.clazzForm.daterange || !self.clazzForm.daterange[0]){
              self.$Message.error("请选择上课起止日期");
              return false;
            }
            if (self.clazzForm.timeList.length == 0){
              self.$Message.error("请选择上课时间段");
              return false;
            }
            let checkTime = true;
            self.clazzForm.timeList.forEach((ele, idx) => {
              if (!ele.start) {
                checkTime = false;
                return false;
              }
              if (!ele.end) {
                checkTime = false;
                return false;
              }
              if (ele.weekday.length == 0) {
                checkTime = false;
                return false;
              }
            });

            if (!checkTime) {
              self.$Message.error("日程设置错误，星期数和时间段不能为空");
              return false;
            }

            if (!self.payForm.money || self.payForm.money <= 0 ){
              self.$Message.error("请输入缴费金额,并且大于0");
              return false;
            }

            if (!self.payForm.hours){
              self.$Message.error("请输入充值课时数");
              return false;
            }

            if (!self.payForm.paytype){
              self.$Message.error("请选择支付方式");
              return false;
            }


          }
        }

        return true;
      },
      packagingFormData(){
        let self = this;
        let signUpInfo = {}
        signUpInfo.isNewStudent = self.baseForm.isNewStudent;
        if (signUpInfo.isNewStudent){
          signUpInfo.student = {
            name:self.baseForm.name,
            sex:self.baseForm.sex,
            birthday:self.baseForm.birth,
            remark:self.baseForm.remark
          }
          signUpInfo.parentList = [];
          if (self.baseForm.linkman1 || self.baseForm.linkman1mobile){
            signUpInfo.parentList.push({
              name:self.baseForm.linkman1,
              mobile:self.baseForm.linkman1mobile
            });
          }
          if (self.baseForm.linkman2 || self.baseForm.linkman2mobile){
            signUpInfo.parentList.push({
              name:self.baseForm.linkman2,
              mobile:self.baseForm.linkman2mobile,
            });
          }
        }else{
          signUpInfo.studentId = self.baseForm.id;
        }
        signUpInfo.zoneId = self.baseForm.zoneId;
        signUpInfo.courseId = self.clazzForm.courseId;
        signUpInfo.teacherId = self.clazzForm.teacherId;
        signUpInfo.courseType = self.clazzForm.courseType;
        signUpInfo.clazzId = self.clazzForm.clazzId;
        signUpInfo.isAppointment = self.clazzForm.isAppointment;
        signUpInfo.appointmentDate = self.clazzForm.appointmentDate;
        signUpInfo.appointmentStartTime = self.clazzForm.appointmentStart;
        signUpInfo.appointmentEndTime = self.clazzForm.appointmentEnd;
        signUpInfo.maxHours = self.clazzForm.hours;
        signUpInfo.hourNum = self.clazzForm.hour_num;
        if (self.clazzForm.daterange && self.clazzForm.daterange[0]){
          signUpInfo.startDate = self.clazzForm.daterange[0];
          signUpInfo.endDate = self.clazzForm.daterange[1];
        }else{
          signUpInfo.startDate = self.clazzForm.startDate;
        }

        signUpInfo.money = self.payForm.money;
        signUpInfo.hours = self.payForm.hours;
        signUpInfo.remark = self.payForm.remark;
        signUpInfo.paytype = self.payForm.paytype;
        let timeListData = [];
        self.clazzForm.timeList.forEach(ele => {
          ele.weekday.sort();
          let one = {...ele};
          one.weekday = one.weekday.join(',');
          timeListData.push(one);
        });
        signUpInfo.timeList = timeListData;
        return {
          signUpInfo:JSON.stringify(signUpInfo)
        };
      },
      submit() {
        let self = this;
        if (self.checkData()){
          self.confirmWin = true;
        }
      },
      teacherCourse() {
        this.teacherModal = true
      },
      addClassTime() {
        this.classTimeModal = true
      },
      saveTime() {
        this.classTimeModal = false;
      },
      appointmentTimeChange(value){
        let timeArray = value.split('-');
        this.clazzForm.appointmentStart = timeArray[0].trim();
        this.clazzForm.appointmentEnd = timeArray[1].trim();
      },
      searchCourse(){
        let self = this;
        self.oneToOneCourseData = self.$store.state.app.oneToOneCourseList.filter(function (item) {
          if (item.name.indexOf(self.courseKeyword)>=0){
            return true;
          }else{
            return false;
          }
        });
      },
      searchClass(){
        this.getClassList();
      }
    },
    mounted() {
      if (this.zoneList && this.zoneList.length > 0){
        this.baseForm.zoneId = this.zoneList[0].id;
        this.baseForm.zoneName = this.zoneList[0].name;
      }

    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
      timeRangeList() {
        return this.$store.state.app.timeList
      },
      studentShowPager : function(){
        return this.studentTotalPage > 1
      },
      classShowPager : function(){
        return this.classTotalPage > 1
      }
    },
    components: {
      TimeList
    }
  }
</script>
